import Vue from 'vue';
import Vuetify from 'vuetify/lib';

import 'vuetify/dist/vuetify.min.css';

Vue.use(Vuetify);

export default new Vuetify({
	theme: {
		options: { customProperties: true },
		dark: false,
		themes: {
			light: {
				primary: '#FF5F05', //Orange
				secondary: '#4D88A1', //Cyan
				accent: '#009CEF', // Blue
				error: '#F44336', //Red
				anchor: '#FF5F05',
				background: '#FFFFFF',
			},
			dark: {
				primary: '#FF5F05',
			},
		},
	},
});
